import script from "./FaqRow.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqRow.vue?vue&type=script&setup=true&lang=js"

import "./FaqRow.vue?vue&type=style&index=0&id=28767470&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28767470"]])

export default __exports__